import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LeadService {

  constructor(private http: CustomHttpService) { }

  getLeadsFields(data: any): Observable<any> {
    return this.http.post(environment.getLeadsFields, data);
  }

  addLeadField(data: any): Observable<any> {
    return this.http.post(environment.addLeadField, data);
  }

  updateLeadField(data: any): Observable<any> {
    return this.http.post(environment.updateLeadField, data);
  }

  deleteLeadField(data: any): Observable<any> {
    return this.http.post(environment.deleteLeadField, data);
  }
  addLeadData(data: any): Observable<any> {
    return this.http.post(environment.createLead, data);
  }

  updateLead(data: any): Observable<any> {
    return this.http.post(environment.updateLead, data);
  }

  getAllLeads(data: any): Observable<any> {
    return this.http.post(environment.getAllLeads, data);
  }

  deleteLead(data: any): Observable<any> {
    return this.http.post(environment.deleteLead, data);
  }

  createBulkLead(data: any): Observable<any> {
    return this.http.post(environment.createBulkLead, data);
  }

  getAllLeadList(data: any): Observable<any> {
    return this.http.post(environment.getAllLeadList, data);
  }

  updateBulkLead(data:any): Observable<any> {
    return this.http.post(environment.updateBulkLead,data);
  }

  // updateBulkLead(data: any): Observable<any> {
  //   if (environment.production) {
  //     return this.http.post(
  //       "https://u4dhxhviheatwcx2osogd6rp6y0evyhb.lambda-url.us-east-1.on.aws/",
  //       data,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json'
  //         }
  //       }
  //     );
  //   } else {
  //     return this.http.post(
  //       "https://5vpvgdfgqrajsuisobpgcyjq6q0qxsic.lambda-url.us-east-1.on.aws",
  //       data,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json'
  //         }
  //       }
  //     );
  //   }
  // }



  deleteBulkLead(data: any): Observable<any> {
    return this.http.post(environment.deleteBulkLead, data);
  }

  getAllLeadSpace(data: any): Observable<any> {
    return this.http.post(environment.getAllLeadSpace, data);
  }

  updateLeadSpace(data: any): Observable<any> {
    return this.http.post(environment.updateLeadSpace, data);
  }

  createLeadSpace(data: any): Observable<any> {
    return this.http.post(environment.createLeadSpace, data);
  }

  deleteLeadSpace(data: any): Observable<any> {
    return this.http.post(environment.deleteLeadSpace, data);
  }

  getLead(data: any): Observable<any> {
    return this.http.post(environment.getLead, data);
  }

  createLeadNote(data: any): Observable<any> {
    return this.http.post(environment.createLeadNote, data);
  }

  updateLeadNote(data: any): Observable<any> {
    return this.http.post(environment.updateLeadNote, data);
  }

  deleteLeadNote(data: any): Observable<any> {
    return this.http.post(environment.deleteLeadNote, data);
  }

  createLeadTask(data: any): Observable<any> {
    return this.http.post(environment.createLeadTask, data);
  }

  getLeadNotes(data: any): Observable<any> {
    return this.http.post(environment.getLeadNotes, data);
  }

  createLeadCommunicationLog(data: any): Observable<any> {
    return this.http.post(environment.createLeadCommunicationLog, data);
  }

  getLeadTasks(data: any): Observable<any> {
    return this.http.post(environment.getLeadTasks, data);
  }

  deleteLeadTask(data: any): Observable<any> {
    return this.http.post(environment.deleteLeadTask, data);
  }

  updateLeadTask(data: any): Observable<any> {
    return this.http.post(environment.updateLeadTask, data);
  }

  createLeadFollowup(data: any): Observable<any> {
    return this.http.post(environment.createLeadFollowup, data);
  }
  getLeadFollowUp(data: any): Observable<any> {
    return this.http.post(environment.getLeadFollowups, data);
  }

  getAllLeadActivity(data: any): Observable<any> {
    return this.http.post(environment.getAllLeadActivity, data);
  }

  sendEmailUsingSES(data: any): Observable<any> {
    return this.http.post(environment.sendEmailUsingSES, data);
  }

  sendCommunication(data: any): Observable<any> {
    return this.http.post(environment.sendCommunication, data);
  }

  getLeadCommunicationLogs(data: any): Observable<any> {
    return this.http.post(environment.getLeadCommunicationLogs, data);
  }

  getAvailableTimeSlots(data: any): Observable<any> {
    return this.http.post(environment.getAvailableTimeSlots, data);
  }

  scheduleMeeting(data: any): Observable<any> {
    return this.http.post(environment.scheduleMeeting, data);
  }

  getLeadMeeting(data: any): Observable<any> {
    return this.http.post(environment.getLeadMeeting, data);
  }

  getLeadDocuments(data: any): Observable<any> {
    return this.http.post(environment.getLeadDocuments, data);
  }

  deleteLeadDocument(data: any): Observable<any> {
    return this.http.post(environment.deleteLeadDocument, data);
  }

  updateApplication(data: any): Observable<any> {
    return this.http.post(environment.updateApplication, data);
  }

  getLeadReportDetails(data: any): Observable<any> {
    return this.http.post(environment.getLeadReportDetails, data);
  }

  getLeadCommunicationReport(data: any): Observable<any> {
    return this.http.post(environment.getLeadCommunicationReport, data);
  }


  moveApplicationToEnrollment(data: any): Observable<any> {
    return this.http.post(environment.moveApplicationToEnrollment, data);
  }

  updateEnrollment(data: any): Observable<any> {
    return this.http.post(environment.updateEnrollment, data);
  }

  getAdmission(data: any): Observable<any> {
    return this.http.post(environment.getAdmission, data);
  }

  findDuplicateWithCount(data: any): Observable<any> {
    return this.http.post(environment.findDuplicateWithCount, data);
  }

  deleteAllDuplicates(data: any): Observable<any> {
    return this.http.post(environment.deleteAllDuplicates, data);
  }

  deleteDuplicateByEmailPhone(data: any): Observable<any> {
    return this.http.post(environment.deleteDuplicateByEmailPhone, data);
  }

  leadAdvanceFilter(data: any): Observable<any> {
    return this.http.post(environment.leadAdvanceFilter, data);
  }

  // Pipeline Configuration APIs
  getPipelines(data: any): Observable<any> {
    return this.http.post(environment.getPipelines, data);
  }

  getAllPipelines(data: any): Observable<any> {
    return this.http.post(environment.getPipelines, data);
  }

  createPipeline(data: any): Observable<any> {
    return this.http.post(environment.createPipeline, data);
  }

  updatePipeline(id: number, data: any): Observable<any> {
    return this.http.post(environment.updatePipeline, { ...data, id: id });
  }

  deletePipeline(id: number): Observable<any> {
    return this.http.post(environment.deletePipeline, { id: id });
  }
}
